'use client';

import { useRouter } from 'next/navigation';
import { createContext, useCallback, useEffect, useState } from 'react';
import UiModal from '../../UiModal';
import type { UiRouteModalContextValue, UiRouteModalProps } from './UiRouteModal.types';

export const UiRouteModalContext = createContext<UiRouteModalContextValue | null>(null);

function UiRouteModal({ children, appear = true, ...props }: UiRouteModalProps) {
    const router = useRouter();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const id = requestAnimationFrame(() => setOpen(true));
        return () => cancelAnimationFrame(id);
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const handleClosed = useCallback(() => {
        router.back();
    }, [router]);

    return (
        <UiRouteModalContext.Provider value={{ close: handleClose }}>
            <UiModal open={open} onClose={handleClose} onClosed={handleClosed} appear={appear} size="lg" {...props}>
                {children}
            </UiModal>
        </UiRouteModalContext.Provider>
    );
}

export default UiRouteModal;
